import { useMemo } from 'react';
import type { CoverTextBox } from 'fym-shared/src/music24/coverDoc';
import { measureCoverText } from '../render/measureCoverText';
import { getMeasureContext } from './measureContext';
import type { StageBoxSize } from './TextBoxLayer';

/**
 * The size of every text box on a stage of `side` CSS pixels, by the measure of the renderer, so
 * the frame sits on the drawn text. It measures again when the fonts load (`isFontsReady`).
 */
export function useStageBoxSizes(texts: readonly CoverTextBox[], side: number, isFontsReady: boolean) {
  return useMemo(() => {
    const measurer = getMeasureContext();
    const sizes: Record<string, StageBoxSize> = {};
    for (const box of texts) {
      const measured = measureCoverText(box, side, measurer);
      const widest = Math.max(measured.boxWidth, ...measured.lineWidths);
      sizes[box.id] = { width: widest, height: measured.boxHeight };
    }
    return sizes;
    // `isFontsReady` is a reason to measure again: the widths change with the real faces.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [texts, side, isFontsReady]);
}
